import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Button } from '@mui/material';
import { ChevronLeft } from '@mui/icons-material';
import BreadCrumbs from '../BreadCrumbs';
import Loading from '../Loading';
import APIUtils from '../../utils/APIUtils';
import AnnotationData from '../AddInterpretation/Sources/AnnotationData';
import AnnotationNamesConfig from '../AddInterpretation/AnnotationNamesConfig';
import '../../index.css';
import './index.css';

export default function VariantAnnotationData() {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const state = location.state || {};

  const variantObjectId = state.variantObjectId || params.variantId;
  const variantName = state.variantName || '';
  const passedBreadCrumbs = state.breadCrumbs || [];

  const [breadCrumbs, setBreadCrumbs] = useState([]);
  const [categories, setCategories] = useState([]);
  const [fieldDescription, setFieldDescription] = useState({});
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    setBreadCrumbs([...passedBreadCrumbs, { name: 'VariantAnnotationData', variantName }]);
    loadAnnotations(variantObjectId);
    loadFieldDescription();
  }, []);

  async function loadAnnotations(id) {
    setLoading(true);
    const resp = await APIUtils.getAnnotationsForVariant(id);
    if (typeof resp !== 'string' && resp && Array.isArray(resp.categories)) {
      setCategories(resp.categories);
    } else {
      setErrorMsg('There was an error loading the annotation data.');
      console.error('There was an error loading the annotations.');
    }
    setLoading(false);
  }

  async function loadFieldDescription() {
    const response = await APIUtils.getFieldDescription();
    if (response) setFieldDescription(response);
  }

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="variantAnnotationData">
      <Loading isLoading={loading} />
      <Helmet>
        <title>ED3N - Variant Annotation Data</title>
      </Helmet>
      <BreadCrumbs breadCrumbs={breadCrumbs} />
      <div className="button-left-right-bar">
        <div>
          <Button
            id="backButton"
            aria-label="Back to Variant Details"
            startIcon={<ChevronLeft />}
            variant="contained"
            color="primary"
            onClick={handleBack}
          >
            Back to Variant Details
          </Button>
        </div>
      </div>
      <section>
        <header>
          <h1 className="pageTitle">Variant Annotation Data</h1>
          {variantName && (
            <p className="variantAnnotationSubHeading">Variant Name: {variantName}</p>
          )}
        </header>
      </section>
      {!loading && (
        errorMsg ? (
          <div className="annotationErrorMsg">{errorMsg}</div>
        ) : (
          categories.map((category) => (
            <div className="section" key={category.categoryName}>
              <h2 className="sectionHeading" tabIndex={-1}>
                {AnnotationNamesConfig[category.categoryName] || category.categoryName}
              </h2>
              <div className="sectionContent">
                <AnnotationData
                  annotationData={category}
                  fieldDescription={fieldDescription}
                  idPrefix={category.categoryName}
                />
              </div>
            </div>
          ))
        )
      )}
    </div>
  );
}
